const cleanDomain = (url) => {
  const parsedUrl = new URL(url)

  // Remove "disclosures" from subdomains
  const cleanHost = parsedUrl.host
    .replace(/^disclosures[.-]?/, '')
    .replace(/\.disclosures[.-]?/, '.')

  return `${parsedUrl.protocol}//${cleanHost}`
}

export default cleanDomain
